import React, { useState, useEffect } from 'react';
import { Page, Panel } from 'src/components/matchbox';
import { connect } from 'react-redux';
import { formatDate, formatInputTime } from '@sparkpost/report-builder/helpers/date';
import { getJobStatus, triggerJob } from 'src/actions/recipientValidation';
import { getBillingInfo } from 'src/actions/account';
import { Form } from 'src/components/tracking';
import Loading from 'src/components/loading';
import { PageLink } from 'src/components/links';
import { RedirectAndAlert } from 'src/components/globalAlert';
import {
  selectRecipientValidationJobById,
  rvAddPaymentFormInitialValues
} from 'src/selectors/recipientValidation';
import { isManuallyBilled } from 'src/selectors/accountBillingInfo';
import ListError from './components/ListError';
import ListProgress from './components/ListProgress';
import UploadedListForm from './components/UploadedListForm';
import ValidateSection from './components/ValidateSection';
import { FORMS } from 'src/constants';
import { reduxForm } from 'redux-form';
import { isProductOnSubscription, prepareCardInfo } from 'src/helpers/billing';
import addRVtoSubscription from 'src/actions/addRVtoSubscription';
import { getSubscription as getBillingSubscription } from 'src/actions/billing';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { isAws } from 'src/helpers/conditions/account';
import { OGOnlyWrapper } from 'src/components/hibana';
import styles from './UploadedListPage.module.scss';

const FORMNAME = FORMS.RV_ADDPAYMENTFORM_UPLOADLISTPAGE;

export function UploadedListPage(props) {
  const {
    getJobStatus,
    listId,
    getBillingInfo,
    getBillingSubscription,
    billing,
    job,
    jobLoadingStatus,
    billing: { credit_card },
    billingLoading,
    valid,
    submitting,
    isRVonSubscription,
    addRVtoSubscriptionloading,
    addRVtoSubscriptionerror,
    triggerJob,
    isAws
  } = props;

  const [useSavedCC, setUseSavedCC] = useState(Boolean(billing.credit_card));

  useEffect(() => {
    getJobStatus(listId);
  }, [getJobStatus, listId]);
  useEffect(() => {
    if (!isAws) {
      getBillingSubscription();
    }
  }, [getBillingSubscription, isAws]);
  useEffect(() => {
    getBillingInfo();
  }, [getBillingInfo]);
  useEffect(() => {
    setUseSavedCC(Boolean(billing.credit_card));
  }, [billing]);

  const handleToggleCC = (val) => setUseSavedCC(!val);

  const handleSubmit = () => {
    triggerJob(listId);
  };

  const onSubmit = (formValues) => {
    const { addRVtoSubscription, isRVonSubscription, isManuallyBilled } = props;

    if (isRVonSubscription && (useSavedCC || isManuallyBilled)) {
      handleSubmit();
      return;
    }

    const values = formValues.card
      ? { ...formValues, card: prepareCardInfo(formValues.card) }
      : formValues;

    return addRVtoSubscription({
      values,
      updateCreditCard: !useSavedCC,
      isRVonSubscription: isRVonSubscription
    }).then(() => handleSubmit());
  };

  if (!job && jobLoadingStatus === 'fail') {
    return (
      <RedirectAndAlert
        alert={{
          message: `Unable to find list ${listId}`,
          type: 'error'
        }}
        to="/recipient-validation"
      />
    );
  }

  if (jobLoadingStatus === 'pending') {
    return <Loading />;
  }

  if (addRVtoSubscriptionloading && !addRVtoSubscriptionerror) return <Loading />;

  return (
    <Form onSubmit={props.handleSubmit(onSubmit)} id="rv-uploadlist-form">
      <Page
        title="Recipient Validation"
        breadcrumbAction={{ content: 'Back', as: PageLink, to: '/recipient-validation' }}
      >
        <Panel.LEGACY>
          <OGOnlyWrapper as={Panel.LEGACY.Section}>
            <div className={styles.dateHeader}>
              <strong>{formatDate.useMomentInput(job.updatedAt)}</strong>
              <span> at </span>
              <strong>{formatInputTime.useMomentInput(job.updatedAt)}</strong>
            </div>
          </OGOnlyWrapper>
          <OGOnlyWrapper as={Panel.LEGACY.Section}>
            {job.status === 'queued_for_batch' && (
              <UploadedListForm job={job} onSubmit={handleSubmit} />
            )}

            {job.status === 'error' && <ListError />}

            {job.status !== 'queued_for_batch' && job.status !== 'error' && (
              <ListProgress job={job} />
            )}
          </OGOnlyWrapper>
        </Panel.LEGACY>
        {job.status === 'queued_for_batch' && !billingLoading && (
          <ValidateSection
            credit_card={credit_card}
            formname={FORMNAME}
            submitDisabled={!valid || submitting}
            handleCardToggle={handleToggleCC}
            defaultToggleState={!useSavedCC}
            isProductOnSubscription={isRVonSubscription}
          />
        )}
      </Page>
    </Form>
  );
}

const mapStateToProps = (state, props) => {
  const { listId } = props.match.params;

  return {
    listId,
    job: selectRecipientValidationJobById(state, listId),
    jobLoadingStatus: state.recipientValidation.jobLoadingStatus[listId] || 'pending',
    billing: state.account.billing || {},
    billingLoading: state.account.billingLoading,
    isRVonSubscription: isProductOnSubscription('recipient_validation')(state),
    initialValues: rvAddPaymentFormInitialValues(state),
    isManuallyBilled: isManuallyBilled(state),
    addRVtoSubscriptionloading: state.addRVtoSubscription.addRVtoSubscriptionloading,
    addRVtoSubscriptionerror: state.addRVtoSubscription.addRVtoSubscriptionerror,
    isAws: isAws(state)
  };
};

const formOptions = { form: FORMNAME, enableReinitialize: true };
export default withRouter(
  connect(mapStateToProps, {
    getJobStatus,
    triggerJob,
    getBillingInfo,
    addRVtoSubscription,
    getBillingSubscription
  })(reduxForm(formOptions)(UploadedListPage))
);
